import React from "react";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import SwitcherLayout from "./SwitcherLayout";
import { Helmet } from "react-helmet";

const linkList = window.location.pathname
  .split("/")
  .filter((item) => (item !== "" ? item : null));
const Settings = (props) => {
  return (
    <SidebarLayout {...props}>
      {/* <BreadCrumb linkList={linkList} /> */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>Settings | Rose Health</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <div className="container-fluid mt-5">
        <SwitcherLayout />
      </div>
    </SidebarLayout>
  );
};

export default Settings;
